var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"DistributorCard"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('CardBasicInfoBlock',{attrs:{"data":{
          thumbnail: _vm.distributor.logo,
          title: _vm.distributor.display_name,
          action: _vm.showDistributorsDetails,
          actionText: _vm.$t('distributorCardContactDetailsButton'),
        }}})],1)]),_c('el-dialog',{attrs:{"visible":_vm.distributorDetailsIsVisible,"title":_vm.$t('contactDetailsPreviewModalTitle')},on:{"update:visible":[function($event){_vm.distributorDetailsIsVisible=$event},_vm.hideDistributorsDetails]}},[_c('DistributorDetails',{attrs:{"distributor":_vm.distributor}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }